module.exports = "\n<input type=\"text\" name=\"search\" class=\"form-control\" placeholder=\"Search\" [(ngModel)]=\"searchString\" (keyup)=\"autoCompileUpdate()\" [appHighlight]=\"highLightColor\">\n<div>\n    <div *ngIf=\"visible\" class=\"autocomplete-items\" style=\"width:300px;\">\n      <div *ngFor=\"let suggestion of suggestions\" (click)=\"setInvisible(suggestion)\"> {{suggestion.description}} </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/template/password-viewer/search/search.component.html
// module id = ./src/app/template/password-viewer/search/search.component.html
// module chunks = main